export default {
  installTitle: 'Установить приложение?',
  installDescription: 'Для быстрого доступа и доступа в режиме офлайн, приложение SLS 24 можно установить на устройство',
}